import ModalService from '@/modules/core/ui/services/ModalService';
import ConfirmModal from '@/modules/core/ui/components/ConfirmModal.vue';
import DocumentUIService from '@/modules/core/app/services/DocumentUIService';
import { AuthUserEvent } from '@/modules/auth/events/AuthUserEvent';
import LogService from '@/integrations/betterstack/LogService';
import { LogIdentifierType } from '@/integrations/betterstack/enums/LogIndentifierType';

export const HandleApiSessionMismatchMixin = {
  data() {
    return {
      sessionMismatchModal: null
    };
  },
  events() {
    return {
      [AuthUserEvent.SESSION_MISMATCH]: this.handleSessionMismatch
    };
  },
  methods: {
    handleSessionMismatch(redirectUrl) {
      if (this.sessionMismatchModal) {
        return;
      }

      this.sessionMismatchModal = ModalService.show({
        parent: this,
        component: ConfirmModal,
        props: {
          title: this.$t('auth.session-mismatch-title'),
          subtitle: this.$t('auth.session-mismatch-subtitle'),
          primaryButtonText: this.$t('auth.session-mismatch-confirm'),
          hideCancel: true,
          confirmFn: () => {
            DocumentUIService.reloadAppAtPath(redirectUrl);
            this.sessionMismatchModal = null;
          }
        },
        canCancel: false
      });

      LogService.warn('Session mismatch detected - showing modal', LogIdentifierType.AUTH_SESSION_MISMATCH, {
        redirectUrl
      });

      this.blurApp();
    },
    blurApp() {
      const appEl = document.getElementById('app');
      if (appEl) {
        appEl.style.filter = 'blur(10px)';
      }
    }
  }
};
